<template>
	<!-- Bank Account Form -->
	<modal class="integration-modal" :size="'medium'" v-if="show" @close="close">
		<div slot="header"><h3><i class="material-icons">account_balance</i>Bank Information</h3></div>
		<div slot="body">
			<div class="integration-actions">
				<div class="form-group">
					<label><b>Bank</b></label>
					<multiselect
						class="form-control"
						track-by="name"
						label="label"
						:options="banks"
						:show-labels="false"
						:preselect-first="true"
						:allow-empty="false"
						v-model="bank">
					</multiselect>
				</div>
				<div class="form-group">
					<label><b>Account Name</b></label>
					<input type="text" name="account_name" class="form-control" placeholder="Account Name.." v-model="accountName" required>
				</div>
				<div class="form-group">
					<label><b>Account Number</b></label>
					<input type="number" name="account_number" class="form-control" placeholder="Account Number.." v-model="accountNumber" @input="onAccountNumberChange" required>
				</div>
				<div class="otp-field" v-if="isShowOtp">
					<otp-field
						type="add_bank_account"
						title=""
						:auto-start-timer="true"
						:generate="isShowOtp"
						v-model="otpCode"
					/>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button
				v-if="!isShowOtp"
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isSaving }"
				:disabled="!isFormValid"
				@click="isShowOtp=true">
				Add New Bank Account
			</button>
			<button
				v-if="isShowOtp"
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isSaving }"
				:disabled="!isFormValid || !isValidOtpFormat"
				@click="add">Submit
			</button>
		</div>
	</modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import OtpField from '@/components/forms/OtpField.vue';
import { banks } from '@/lib/statics';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'bankAccountsModalWithOtp',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		otpRequired: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Modal,
		OtpField,
	},
	data() {
		return {
			banks,
			bank: null,
			accountName: '',
			accountNumber: '',
			isSaving: false,
			isShowOtp: false,
			otpCode: '',
		};
	},
	methods: {
		...mapActions({
			addBankAccount: 'addBankAccount',
			addBankAccountWithOtp: 'addBankAccountWithOtp',
			removeBankAccount: 'removeBankAccount',
		}),
		reset() {
			this.accountName = '';
			this.accountNumber = '';
			this.otpCode = '';
		},
		close() {
			this.isShowOtp = false;
			this.$emit('close');
		},
		add() {
			if (this.isFormValid && this.bank) {
				this.isSaving = true;
				const bankAccount = {
					name: this.bank.name,
					label: this.bank.label,
					account_name: this.accountName,
					account_number: this.accountNumber,
				};
				const cb = () => {
					this.isSaving = false;
					this.isShowOtp = false;
					this.reset();
					this.close();
				};
				const errorCb = (e) => {
					this.isSaving = false;
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						title: 'Bank Account',
						text: message ?? 'Failed to add bank account',
						type: 'error',
					});
				};
				const params = {
					bank_account: bankAccount,
					code: this.otpCode,
				};
				this.addBankAccountWithOtp({ params, cb, errorCb });
			}
		},
		remove(index) {
			this.isSaving = true;
			const cb = () => {
				this.isSaving = false;
			};
			const errorCb = () => {
				this.isSaving = false;
			};
			this.removeBankAccount({ index, cb, errorCb });
		},
		onAccountNumberChange(e) {
			let value = e.target.value;
			if (!Number.isNaN(value)) {
				value = value.toString();
			}
			this.accountNumber = value;
		},
	},
	computed: {
		isFormValid() {
			const isFormValid = this.accountName !== '' && this.accountNumber !== '';
			return isFormValid;
		},
		isValidOtpFormat() {
			return this.otpCode.toString().length === 6;
		},
	},
};
</script>
